import axios from "axios";
import { ApiPath } from "../../../common/api-path/ApiPath";

export const getCircuitVpnLogs = async (requestParams) => {
    const requestConfig = {
        params: requestParams,
        timeout: 12000,
        timeoutErrorMessage: "Request timed out while fetching Circuit VPN logs.",
    }
    const response = await axios.get(`${ApiPath.baseUrl}/circuit-vpn/events`, requestConfig);
    if (response.status >= 400) {
        throw new Error(response.errors);
    }
    return response.data;
}

export const getCircuitVpnDetailsByEvents = async (requestId) => {
    const requestConfig = {
        params: {requestId},
        timeout: 12000,
        timeoutErrorMessage: "Request timed out while fetching NAC automation details.",
    }
    const response = await axios.get(`${ApiPath.baseUrl}/circuit-vpn/event/messages`, requestConfig);
    if (response.status >= 400) {
        throw new Error(response.errors);
    }
    return response.data;
}